<template>
  <div class="d-flex flex-column">
    <div class="d-flex flex-wrap" style="gap: 1rem">
      <div class="d-flex flex-column">
        <span class="me-3 mb-2">Date From: </span>
        <DatePicker
          v-model="from"
          :auto-apply="true"
          :enable-time-picker="false"
          placeholder="Start Date"
          :format="'MM/dd/yyyy'"
          :max-date="to || new Date()"
        />
      </div>
      <div class="d-flex flex-column">
        <span class="me-3 mb-2">Date To: </span>
        <DatePicker
          v-model="to"
          :auto-apply="true"
          :enable-time-picker="false"
          :format="'MM/dd/yyyy'"
          placeholder="End Date"
          :min-date="from"
          :max-date="limitTo"
        />
      </div>
      <div class="d-flex flex-column">
        <span class="me-3 mb-2">Type: </span>
        <select
          class="form-select shadow-none"
          style="width: 176px; padding: 6px 12px"
          v-model="selectedOption"
        >
          <option value="" disabled selected hidden>Select Type</option>
          <option v-for="data in options" :key="data.id" :value="data.value">
            {{ data.label }}
          </option>
        </select>
      </div>
      <div class="d-flex flex-column">
        <span class="me-3 mb-2">Email send to: </span>
        <input
          class="form-control shadow-none"
          style="width: 176px; padding: 6px 12px"
          v-model="email"
          placeholder="Email"
          type="email"
        />
        <span v-if="errors.email" class="text-danger">{{ errors.email }}</span>
      </div>
    </div>
    <button
      :disabled="disabledButton"
      @click="handleRequest"
      class="btn btn-lg btn-danger fw-bold mt-3"
      style="max-width: 176px"
    >
      Send Request
    </button>
  </div>
</template>

<script>
import DatePicker from "@vuepic/vue-datepicker";
import moment from "moment";
import "@vuepic/vue-datepicker/dist/main.css";
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      from: "",
      to: "",
      options: [
        { value: "Order", id: 1, label: "Order" },
        { value: "SellerRefund", id: 2, label: "Refund" },
        { value: "SellerWithdraw", id: 3, label: "Withdraw" },
        { value: "Seller", id: 4, label: "Seller" },
        { value: "SellerBalance", id: 5, label: "Seller Balance" },
        { value: "Product", id: 6, label: "Product" },
        { value: "SellerIncome", id: 7, label: "Income" },
      ],
      selectedOption: "",
      email: "",
      errors: {},
    };
  },
  watch: {
    from() {
      if (this.is30day) {
        this.to = "";
      }
    },
  },
  computed: {
    is30day() {
      const diffToFromNow = moment(new Date()).diff(moment(this.from), "days");
      if (diffToFromNow && diffToFromNow >= 30) {
        return true;
      }
      return false;
    },
    limitTo() {
      if (this.from && this.is30day) {
        return moment(this.from).add(30, "days");
      }
      return new Date();
    },
    disabledButton() {
      return !this.from || !this.to || !this.selectedOption || !this.email;
    },
  },
  methods: {
    clearForm() {
      this.from = "";
      this.to = "";
      this.selectedOption = "";
      this.email = "";
    },
    async handleRequest() {
      this.errors = {};
      if (!this.filters.validateEmail(this.email)) {
        this.errors.email = "Invalid Email Format";
        return;
      }
      const payload = {
        date_start: moment(this.from).format("YYYY-MM-DD"),
        date_end: moment(this.to).format("YYYY-MM-DD"),
        type: this.selectedOption,
        email: this.email,
      };
      try {
        await this.$store.dispatch("reports/create", payload);
        this.$swal({
          icon: "success",
          title: "Success Send Request",
          showConfirmButton: false,
          timer: 1500,
        });
        this.clearForm()
      } catch (err) {
        let msg = "Something Went Wrong"
        const errorCode = err?.response?.data?.errorCode
        const errorMessage = err?.response?.data?.errorMessage
        if(errorCode){
          msg = errorMessage
        }
        this.$swal({
          icon: "error",
          title: msg,
          text: "Failed Send Request",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
};
</script>

<style></style>
